import { render, staticRenderFns } from "./simpleProjectArrow.vue?vue&type=template&id=d53978b2&scoped=true&"
import script from "./simpleProjectArrow.vue?vue&type=script&lang=js&"
export * from "./simpleProjectArrow.vue?vue&type=script&lang=js&"
import style0 from "./simpleProjectArrow.vue?vue&type=style&index=0&id=d53978b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53978b2",
  null
  
)

export default component.exports